<template>
  <div class="customer-advance-field">
    <div class="customer-advance-label-row">
      <label class="customer-advance-label">{{ label }}</label>
      <span v-if="formattedMax" class="customer-advance-max"
        >{{ maxLabel }}: {{ formattedMax }}</span
      >
    </div>
    <v-text-field
      :value="value"
      class="pt-0 customer-advance-input"
      type="text"
      inputmode="decimal"
      single-line
      hide-details
      :suffix="currency"
      :placeholder="fetching ? 'Loading...' : placeholder"
      :disabled="disabled || fetching"
      @input="onInput"
      @keypress="blockInvalidAmountKey"
      @keyup.enter="$emit('enter')"
    ></v-text-field>
    <div v-if="error" class="customer-advance-error">{{ error }}</div>
    <div v-else-if="hint" class="customer-advance-hint">{{ hint }}</div>
  </div>
</template>

<script>
import {
  blockInvalidAmountKey,
  formatAmount,
  limitToTwoDecimals,
  normaliseMax,
} from "@/utils/customerAdvance";
export default {
  name: "CustomerAdvanceAmountField",
  props: {
    /* v-model, the raw string in the field */
    value: {
      type: String,
      default: "",
    },
    label: {
      type: String,
      default: "Customer Advance Amount",
    },
    placeholder: {
      type: String,
      default: "Enter amount",
    },
    hint: {
      type: String,
      default: "",
    },
    /* Shown under the field in place of the hint. */
    error: {
      type: String,
      default: "",
    },
    /* Ceiling for the amount. Null or 0 leaves it uncapped. */
    maxAmount: {
      type: [Number, String],
      default: null,
    },
    /* What the ceiling is called, used beside the label. */
    maxLabel: {
      type: String,
      default: "Customer Amount",
    },
    /* Shown as a suffix inside the input, e.g. AED */
    currency: {
      type: String,
      default: "",
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    /* The saved amount is still being fetched. */
    fetching: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    formattedMax() {
      return formatAmount(normaliseMax(this.maxAmount), this.currency);
    },
  },
  methods: {
    blockInvalidAmountKey,
    onInput(value) {
      this.$emit("input", limitToTwoDecimals(value));
    },
  },
};
</script>

<style scoped>
.customer-advance-label-row {
  align-items: baseline;
  display: flex;
  gap: 0.5rem;
  justify-content: space-between;
  padding-bottom: 0.375rem;
}
.customer-advance-label {
  color: #64748b;
  font-size: 0.75rem;
  font-weight: 600;
}
.customer-advance-max {
  color: #94a3b8;
  font-size: 0.6875rem;
  white-space: nowrap;
}
.customer-advance-hint {
  color: #94a3b8;
  font-size: 0.6875rem;
  padding-top: 0.375rem;
}
.customer-advance-error {
  color: var(--oms-red, #ff0000);
  font-size: 0.7875rem;
  font-weight: 700;
  padding-top: 0.375rem;
}
</style>
